import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers'; // Asegúrate de que este sea tu reducer combinado

const store = configureStore({
  reducer: rootReducer, // Tu rootReducer
  devTools: process.env.NODE_ENV !== 'production', // Habilita Redux DevTools solo en desarrollo
});

export default store;
